import { UseFormReturn } from 'react-hook-form';
import { FormattedMessage, useIntl } from 'react-intl';

import { DAY_OF_WEEK } from 'src/features/membershipType/types';
import { DAY_OF_WEEK_TRANSLATIONS_MAP } from 'src/features/membershipType/utils/constants';
import { AllowedTimeFormSchemaValues } from 'src/features/membershipType/formSchema';
import { allowedTimesMessages } from 'src/features/membershipType/utils/messages';
import SelectFormField from 'src/registry/components/forms/SelectFormField';
import { Form, FormControl, FormControlStack, FormField, FormItem, FormLabel, FormMessage } from 'src/registry/ui/Form';
import { Input } from 'src/registry/ui/Input';

type AllowedTimeFormProps = {
    form: UseFormReturn<AllowedTimeFormSchemaValues>;
    onSubmit: (values: AllowedTimeFormSchemaValues) => void;
};

function AllowedTimeForm({ onSubmit, form }: AllowedTimeFormProps) {
    const { formatMessage } = useIntl();

    return (
        <Form form={form} onSubmit={form.handleSubmit(onSubmit)} variant="dialog">
            <SelectFormField<AllowedTimeFormSchemaValues>
                form={form}
                required
                name="day_of_week"
                label={formatMessage(allowedTimesMessages.dayOfWeek)}
                options={Object.values(DAY_OF_WEEK)}
                optionTranslationMap={DAY_OF_WEEK_TRANSLATIONS_MAP}
            />

            <FormField
                control={form.control}
                name="from_time"
                render={({ field }) => (
                    <FormItem variant="dialog">
                        <FormLabel variant="dialog" required>
                            <FormattedMessage {...allowedTimesMessages.from} />
                        </FormLabel>
                        <FormControlStack>
                            <FormControl>
                                <Input type="time" {...field} value={field.value ?? ''} />
                            </FormControl>
                            <FormMessage />
                        </FormControlStack>
                    </FormItem>
                )}
            />
            <FormField
                control={form.control}
                name="to_time"
                render={({ field }) => (
                    <FormItem variant="dialog">
                        <FormLabel variant="dialog" required>
                            <FormattedMessage {...allowedTimesMessages.to} />
                        </FormLabel>
                        <FormControlStack>
                            <FormControl>
                                <Input type="time" {...field} value={field.value ?? ''} />
                            </FormControl>
                            <FormMessage />
                        </FormControlStack>
                    </FormItem>
                )}
            />
        </Form>
    );
}

export default AllowedTimeForm;
